import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { oneKlicks } from "../../../../SDK/oneclick";
import { getuserdata } from "../../../../services/apiService";
import { toast } from "react-toastify";
import { countries, statesByCountry } from "../../../../Uitiles/countries";




const InvoiceSettings = ({ localInvoice, setLocalInvoice, userId }) => {

    useEffect(() => {
        getInvoiceSettings();
    }, [userId]);

    const getInvoiceSettings = async () => {
        try {
            const tableSchema = "";
            const tableName = "users_billing_details";
            const conditions = {
                "user_id": userId || await getuserdata("id")
            };
            const orderBy = "id DESC";
            const search = null;
            const pagination = null;
            const margedata = null;
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success && response.data.length > 0) {
                setLocalInvoice(response.data[0]);
            }
        } catch (error) {
            console.error("Error fetching invoice settings:", error);
        }
    };

    const handleChange = (field, value) => {
        setLocalInvoice({ ...localInvoice, [field]: value });
        
        // Reset state when country changes
        if (field === 'country') {
            setLocalInvoice(prev => ({ ...prev, state: '' }));
        }
    };

    // Get available states based on selected country
    const getAvailableStates = () => {
        const selectedCountry = localInvoice.country;
        return statesByCountry[selectedCountry] || [];
    };




    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-securityhold tab-pane active fade show" id="dc-security">
                <div className="dc-securitysettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Invoice Settings</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding">
                        <Form>
                            <h6>Billing Details</h6>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Name"
                                            value={localInvoice.name || ''}
                                            onChange={(e) => handleChange('name', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Email"
                                            value={localInvoice.email || ''}
                                            onChange={(e) => handleChange('email', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Phone</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Phone"
                                            value={localInvoice.phone || ''}
                                            onChange={(e) => handleChange('phone', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Website</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Website"
                                            value={localInvoice.website || ''}
                                            onChange={(e) => handleChange('website', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>GST Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="GST Number"
                                            value={localInvoice.gst_number || ''}
                                            onChange={(e) => handleChange('gst_number', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Country</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={localInvoice.country || ''}
                                            search={true}
                                            onChange={(e) => handleChange('country', e.target.value)}
                                        >
                                            <option value="">Select Country</option>
                                            {countries.map((country, index) => (
                                                <option key={index} value={country}>
                                                    {country}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>State</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={localInvoice.state || ''}
                                            onChange={(e) => handleChange('state', e.target.value)}
                                            disabled={!localInvoice.country}
                                        >
                                            <option value="">
                                                {localInvoice.country ? 'Select State' : 'Select Country First'}
                                            </option>
                                            {getAvailableStates().map((state, index) => (
                                                <option key={index} value={state}>
                                                    {state}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>City</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="City"
                                            value={localInvoice.city || ''}
                                            onChange={(e) => handleChange('city', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Pincode</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Pincode"
                                            value={localInvoice.pincode || ''}
                                            onChange={(e) => handleChange('pincode', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Address</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Address"
                                            value={localInvoice.address || ''}
                                            onChange={(e) => handleChange('address', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceSettings;
